import mdcButton from './mdc-button.vue'
export const mdcButtonComponents = {
  mdcButton,
}